/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Only production builds report. The dev stores and localhost build with the
// development configuration (environment.production false) and were filling
// the production quota with their own errors.
if (environment.production) {
  Sentry.init({
    dsn: "https://4ebb8539a41b456ff012464a333debc6@o4508162247557120.ingest.us.sentry.io/4509124097015808",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // A tab still on the previous build asks for lazy chunks the deploy removed.
    // ChunkReloadErrorHandler reloads it onto the new build, so these are not
    // actionable, and right after a deploy they arrive in bursts large enough to
    // exhaust the Sentry quota (429s). Drop them at the source.
    ignoreErrors: [
      'Failed to fetch dynamically imported module',
      'error loading dynamically imported module',
      'Importing a module script failed',
      'Failed to load module script',
      /Loading (CSS )?chunk/,
      'ChunkLoadError',
      'NG0750',
    ],
    // Tracing
    tracesSampleRate: 0, // off: transactions were burning the shared quota (DEV-11772)
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^https:\/\/petwants\.navego\.tech/,
      /^https:\/\/petwantscincy\.com/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0, // record only the sessions that hit an error
    replaysOnErrorSampleRate: 1.0,
  });
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
